import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Button, Stack, Text, RadioGroup, Radio, Box, useMultiStyleConfig} from '@chakra-ui/react'
import WebDrawer from '../../../../components/web-drawer'
import AddressDisplay from './address-display'

const PartiallyValidDrawer = ({
    isOpen,
    onClose,
    enteredAddress,
    suggestions,
    selectedAddress,
    setSelectedAddress
}) => {
    const styles = useMultiStyleConfig('AddressValidationDrawer', {})
    return (
    <WebDrawer
        noBodyStyle={true}
        isOpen={isOpen}
        onClose={() => onClose(false)}
        size="hug"
        headerInContent
        footer={
            <Button
                variant="webPrimary"
                w={'100%'}
                onClick={() => onClose(true)}
                isDisabled={!selectedAddress}
            >
                <FormattedMessage
                    defaultMessage="Use selected address"
                    id="shipping_address.modal.use_selected_address"
                />
            </Button>
        }
    >
        <Box {...styles.body}>
            <Text {...styles.title} mb={5}>
                <FormattedMessage
                    defaultMessage="Please double-check your address"
                    id="shipping_address.modal.double_check_address_title"
                />
            </Text>
            <Text {...styles.description} mb={5}>
                <FormattedMessage
                    defaultMessage="The city, province and postal code combination provided does not match. Please use the suggested address or correct the address to continue."
                    id="shipping_address.modal.use_suggested_address_text"
                />
            </Text>
            <RadioGroup onChange={setSelectedAddress} value={selectedAddress}>
                <Stack spacing={5}>
                    <Stack spacing={3}>
                        <Text {...styles.label}>
                            <FormattedMessage
                                defaultMessage="You Entered:"
                                id="shipping_address.modal.you_entered"
                            />
                        </Text>
                        <Radio value="entered" {...styles.radio}>
                            <AddressDisplay address={enteredAddress} />
                        </Radio>
                    </Stack>
                    <Stack spacing={3}>
                        <Text {...styles.label}>
                            <FormattedMessage
                                defaultMessage="Suggested Address:"
                                id="shipping_address.modal.suggested_address"
                            />
                        </Text>
                        <Radio value="suggested" isChecked {...styles.radio}>
                            {suggestions && suggestions.length > 0 && (
                                <AddressDisplay address={suggestions[0]} />
                            )}
                        </Radio>
                    </Stack>
                    <Button variant="unstyled" w={'100%'} {...styles.link} onClick={() => onClose(false)}>
                        <Text as='span' {...styles.link}>
                            <FormattedMessage
                                defaultMessage="Modify my address"
                                id="shipping_address.modal.modify_address"
                            />
                        </Text>
                    </Button>
                </Stack>
            </RadioGroup>
        </Box>
    </WebDrawer>
    )
}

PartiallyValidDrawer.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    enteredAddress: PropTypes.object.isRequired,
    suggestions: PropTypes.array.isRequired,
    selectedAddress: PropTypes.string,
    setSelectedAddress: PropTypes.func.isRequired
}

export default PartiallyValidDrawer
